import styled from 'styled-components'

import { reactTableLoaderTypes } from '../../Loader/constants'

export const ListViewLoadingWrapper = styled.div``

export const ListViewTableWrapper = styled.div<{
   reactTableLoaderType: string
}>`
   padding: ${props => {
      switch (props.reactTableLoaderType) {
         case reactTableLoaderTypes.advancedBoardSubtask:
            return '10px 10px'
         case reactTableLoaderTypes.taskDetailedViewSubtask:
            return '10px 0px'
         case reactTableLoaderTypes.taskDetailedViewRelatedTask:
            return '10px 0px'
         case reactTableLoaderTypes.bucketTableView:
            return '10px 0px'
         case reactTableLoaderTypes.advancedBoardListView:
            return '10px 16px'
         case reactTableLoaderTypes.advancedBoardSingleListView:
            return '36px 16px'
         case reactTableLoaderTypes.advancedBoardListViewPagination:
            return '36px 0px'
         default:
            return '10px 16px'
      }
   }};
   margin: ${props => {
      if (
         props.reactTableLoaderType ===
         reactTableLoaderTypes.advancedBoardListView
      ) {
         return '24px 0px'
      }
      return ''
   }};
   div:nth-child(1) {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
   }
   div:nth-child(${props => props.numberOfTaskInTable}) {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
   }
`

export const AdhocTasksLoader = styled.div`
   background: #fff;
   padding: 5px;
   margin: 0px;
   display: flex;
   align-items: center;
   border: 1px solid #e4e7eb;
   width: 100%;
   display: flex;
   align-items: center;
   justify-content: space-evenly;
   & > span {
      display: flex;
      flex-grow: 1;
      max-width: 200px;
   }
   span:nth-child(1) {
      flex-grow: 0;
   }
   span:nth-child(2) {
      display: flex;
      flex-grow: 2;
      max-width: 460px;
   }
   span:nth-child(3) {
      flex-grow: 0;
   }
   span:nth-child(4) {
      flex-grow: 0;
   }
`
